// src/api/uploadApi.js
import { apiRequest } from '@/api'

export const uploadApi = {
  /**
   * 上传图片
   * @param {string} base64 - Base64图片数据
   * @param {string} type - 图片类型: 'style' | 'logo'
   * @returns {Promise}
   */
  uploadImage(base64, type = 'style') {
    return apiRequest('/api/upload/image', {
      method: 'POST',
      body: { base64, type }
    })
  },

  // 删除图片
  deleteImage(filePath) {
    return apiRequest('/api/upload/delete', {
      method: 'POST',
      body: { filePath }
    })
  }
}